var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-section',{attrs:{"title":_vm.Info.Section.TransactionSetting.Title}},[_c('kst-output',{attrs:{"field":"DiscPercent","data":_vm.data,"catalog":_vm.Catalog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }